export default __webpack_public_path__ + "static/GraphikLCWeb-RegularItalic-6818b70ef3d1a8a882e97724150eccf1.woff2";